import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  addBookmark,
  addBusiness,
  addCallers,
  addViews,
  deleteBusiness,
  editBussiness,
  getBookmark,
  getBusinessDetails,
  getBusinessList,
  getCurrentPlan,
  getDetails,
  getMyBussiness,
  getRating,
  getSubcriptionPlan,
  getTrialplanDetails,
  updateRating,
  getCallCount,
  addHomeViews,
  getHomeViews,
} from "./bussinessUrl";

const Get_my_bussiness = () => {
  return useQuery(["businessList"], () => getMyBussiness(), {
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  });
};

const Get_bussiness_list = (query) => {
  return useQuery(["bussiness", query], () => getBusinessList(query), {
    cacheTime: 0,  // Disable caching to ensure fresh data
    staleTime: 0,  // Consider data stale immediately
    refetchOnWindowFocus: false,  // Don't refetch on window focus
    refetchOnReconnect: false,  // Don't refetch on reconnect
  });
};

const Get_subcription = (id) => {
  return useQuery(["subscription", id], () => getSubcriptionPlan(id), {
    enabled: !!id,
  });
};

const Get_my_bussiness_details = (id) => {
  return useQuery(["businessDetails", id], () => getBusinessDetails(id), {
    enabled: !!id,
    staleTime: 0,

    cacheTime: 0,
    refetchOnMount: "always",
  });
};

const Get_my_currentplan = (id) => {
  return useQuery(["currentPlan", id], () => getCurrentPlan(id), {
    enabled: !!id,
    staleTime: 0,
    refetchOnMount: "always",
  });
};

const Get_details = (id) => {
  return useQuery(["getDetails", id], () => getDetails(id), {
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  })
};

const Get_bookmark_list = (userID) => {
  return useQuery(["bookmarkList"], () => getBookmark(), {
    enabled: !!userID,
  })
};

const Get_rating = (id) => {
  return useQuery(["ratingList", id], () => getRating(id), {
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};

const Get_trial_plan = () => {
  return useQuery(["trialPlan"], () => getTrialplanDetails());
};

const Get_call_count = (id) => {
  return useQuery(["callCount", id], () => getCallCount(id), {
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};

const Add_views = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => addViews(data), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("businessList");
      const prev = await queryClient.getQueryData("businessList");
      return {
        prev,
        newData,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("businessList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("businessList", context.prev);
    },
  });
};

const Get_home_views = () => {
  return useQuery(["homeViews"], () => getHomeViews(), {
    staleTime: 0,
    cacheTime: 0,
  });
};

const Add_home_views = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => addHomeViews(data), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("homeViews");
      const prev = await queryClient.getQueryData("homeViews");
      return {
        prev,
        newData,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("homeViews");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("homeViews", context.prev);
    },
  });
};


const Add_calls = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => addCallers(data), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("businessDetails");
      const prev = await queryClient.getQueryData("businessDetails");
      return {
        prev,
        newData,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("businessDetails");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("businessDetails", context.prev);
    },
  });
};

const Add_business = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => addBusiness(data), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("businessList");
      const prev = await queryClient.getQueryData("businessList");
      return {
        prev,
        newData,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("businessList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("businessList", context.prev);
    },
  });
};

const Edit_business = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => editBussiness(data), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("businessList");
      const prev = await queryClient.getQueryData("businessList");
      return {
        prev,
        newData,
      };
    },
    onSettled: (_d, _e, variables) => {
      queryClient.invalidateQueries("businessList");
      queryClient.invalidateQueries(["businessDetails", variables?.id]);
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("businessList", context.prev);
    },
  });
};

const Del_business = () => {
  const queryClient = useQueryClient();

  return useMutation((id) => deleteBusiness(id), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("businessList");
      const prev = await queryClient.getQueryData("businessList");
      return {
        prev,
        newData,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("businessList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("businessList", context.prev);
    },
  });
};

const Add_bookmark = () => {
  const queryClient = useQueryClient();

  return useMutation((businessId) => addBookmark(businessId), {
    onMutate: async (businessId) => {
      queryClient.cancelQueries("bookmarkList");
      const prev = await queryClient.getQueryData("bookmarkList");
      
      // Optimistic update: toggle bookmark in cache
      if (prev && prev.data && prev.data.results) {
        const isBookmarked = prev.data.results.some((item) => item.id === businessId);
        
        if (isBookmarked) {
          // Remove from bookmarks
          const updated = {
            ...prev,
            data: {
              ...prev.data,
              results: prev.data.results.filter((item) => item.id !== businessId)
            }
          };
          queryClient.setQueryData("bookmarkList", updated);
        } else {
          // Add to bookmarks - we'll add a placeholder, API will return actual data
          const updated = {
            ...prev,
            data: {
              ...prev.data,
              results: [...prev.data.results, { id: businessId }]
            }
          };
          queryClient.setQueryData("bookmarkList", updated);
        }
      }
      
      return {
        prev,
        businessId,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("bookmarkList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("bookmarkList", context.prev);
    },
  });
};

const Update_rating = () => {
  const queryClient = useQueryClient();

  return useMutation((data) => updateRating(data), {
    onMutate: async (newData) => {
      queryClient.cancelQueries("ratingList");
      const prev = await queryClient.getQueryData("ratingList");
      return {
        prev,
        newData,
      };
    },
    onSettled: () => {
      queryClient.invalidateQueries("ratingList");
    },
    onError: (err, _, context) => {
      queryClient.setQueryData("ratingList", context.prev);
    },
  });
};

const useBusinessQuery = {
  Add_business,
  Get_my_bussiness,
  Del_business,
  Get_subcription,
  Get_my_bussiness_details,
  Edit_business,
  Get_bussiness_list,
  Get_bookmark_list,
  Add_bookmark,
  Get_my_currentplan,
  Get_rating,
  Update_rating,
  Get_details,
  Get_trial_plan,
  Add_views,
  Add_home_views,
  Get_home_views,
  Add_calls,
  Get_call_count
};

export default useBusinessQuery;
